import { create } from 'zustand';

export type SessionOwner = { id: string; tenantId: string; impersonation?: { sessionId: string } };
export const sessionRealm = (owner: Pick<SessionOwner, 'impersonation'> | null) =>
  owner?.impersonation ? `impersonation:${owner.impersonation.sessionId}` : 'normal';
type RecoveryPhase = 'idle' | 'probing' | 'choice' | 'restoring' | 'following' | 'login-required' | 'offline';

// Deliberately separate from persisted auth: pausing A must never overwrite B's
// confirmed localStorage snapshot. No probed profile is retained here.
export const useSessionRecovery = create<{
  generation: number;
  phase: RecoveryPhase;
  owner: SessionOwner | null;
  realm: string;
  observedTenantId: string | null;
  restoreDenied: boolean;
}>(() => ({ generation: 0, phase: 'idle', owner: null, realm: 'normal', observedTenantId: null, restoreDenied: false }));

export const sessionPaused = () => useSessionRecovery.getState().phase !== 'idle';

export function beginSessionRecovery(owner: SessionOwner | null) {
  if (!owner || sessionPaused()) return;
  useSessionRecovery.setState((state) => ({
    generation: state.generation + 1, phase: 'probing',
    owner: { id: owner.id, tenantId: owner.tenantId }, realm: sessionRealm(owner), observedTenantId: null, restoreDenied: false,
  }));
}

export function finishSessionRecovery() {
  useSessionRecovery.setState((state) => ({
    generation: state.generation + 1, phase: 'idle', owner: null, realm: 'normal',
    observedTenantId: null, restoreDenied: false,
  }));
}
